import axios from '../../utils/http/http';
import { triggerNotification } from '../../utils/NotificationContext';

export const fetchMasterData = async (data = {}) => {
  try {
    const response = await axios.postRequest(
      `/tpo/portfolioMasterData/filterPortfolioMasterTable`,
      data
    );

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchCompleteMasterData = async () => {
  try {
    const response = await axios.getRequest(`/tpo/portfolioMasterData/getSkuLevelMasterData`);

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to download data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchPortfolioOptionsValueWhileEditingCell = async () => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/fetchPortfolioOptionsValueWhileEditingCell`,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchTpoSkuMasterData = async () => {
  try {
    const response = await axios.getRequest(`/tpo/portfolioMasterData/getTpoSkuMasterData`);

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to download data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchMaterialMasterData = async (BusinessUnitName, pageNumber) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/getPortfolioMasterData/${encodeURIComponent(BusinessUnitName)}/${pageNumber}`
    );

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchQualityCheckData = async () => {
  try {
    const response = await axios.getRequest(`/tpo/portfolioMasterData/checkItems`);

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchBlankFieldsValue = async (selectedBu) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/totalSKUAttention/${encodeURIComponent(selectedBu)}`
    );

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchQualityItemsBannerValue = async (selectedBu) => {
  try {
    const response = await axios.getRequest(`/tpo/portfolioMasterData/checkItems/${encodeURIComponent(selectedBu)}`);

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
}

export const fetchKpiCardData = async (selectedBu) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/getPortfolioMasterKPI/${encodeURIComponent(selectedBu)}`
    );
    console.log(response);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const bulkUploadFile = async (formData, onUploadProgress) => {
  try {
    const response = await axios.postRequest(`/tpo/portfolioMasterData/bulkupload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress
    });
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Bulk Upload Failed!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchCurrentTimeFrame = async (selectedBu, timeFrame) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/getTimeFrame/${encodeURIComponent(selectedBu)}?timeFrame=${timeFrame}`
    );

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const updatePortfolioMasterData = async (params) => {
  try {
    const response = await axios.postRequest(
      `/tpo/portfolioMasterData/updatePortfolioMasterData`,
      params
    );

    const successMessage = response;
    triggerNotification(successMessage, 'success');
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data;
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const getDropdownListByFilterParam = async (selectedBu) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioHealth/getDropdownListByFilterParam/${encodeURIComponent(selectedBu)}`
    );
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data;
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const getUserActionSummary = async (cycleId, userRole, userName) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioHealth/userActionsSummary?cycleId=${cycleId}&userRole=${userRole}&userName=${userName}`
    );
    return response;
  } catch (error) {
    const errorMessage = error?.response?.data;
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchMaterialDetailByTPOSKU = async (TPOSKU, selectedBu) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/fetchMaterialDetailByTPOsku/${encodeURIComponent(selectedBu)}/${TPOSKU}`
    );
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to delete data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchPortfolioHealthDataByFilterParam = async (params) => {
  try {
    const response = await axios.postRequest(
      `/tpo/portfolioHealth/getPortfolioHealthDataByFilterParam`,
      params
    );
    const successMessage = response;
    triggerNotification(successMessage, 'success');
    const data = [{ ...response }];
    return data;
  } catch (error) {
    const errorMessage = error?.message;
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchTrendAnalysisChartDataByFilterParam = async (params) => {
  try {
    const response = await axios.postRequest(
      `/tpo/portfolioHealth/getTrendAnalysisChartDataByFilterParam`,
      params
    );

    const data = [{ ...response }];
    return data;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchCardSummaryAndChartsData = async (selectedBu) => {
  try {
    const local_bu = localStorage.getItem('bu_name');
    const response = await axios.getRequest(
      `/tpo/portfolioHealth/getCardSummaryAndChartsData/${encodeURIComponent(local_bu)}`
    );
    const data = [{ ...response }];

    return data;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
export const fetchLineChartData = async (params) => {
  try {
    const response = await axios.postRequest('/tpo/portfolioHealth/getLineChartData', params);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get line chart data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
export const fetchLineAndBarChartData = async (params) => {
  try {
    const fetchAPI2 = () => axios.postRequest('/tpo/portfolioHealth/getLineChartData', params);

    const responses = await Promise.all([fetchAPI2()]);

    return responses;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchBarChartData = async (params) => {
  try {
    const fetchAPI3 = () => axios.postRequest('/tpo/portfolioHealth/getBarChartData', params);

    const response = await fetchAPI3();

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
export const fetchPortfolioHealthKPIAndChartsData = async (params) => {
  try {
    const fetchAPI1 = () =>
      axios.postRequest('/tpo/portfolioHealth/getActualVsPreviousPeriodData', params);

    const responses = await Promise.all([fetchAPI1()]);

    console.log('prasresponse', responses);
    return responses;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchActualVsPreviousPeriodData = async (payload) => {
  const response = await axios.postRequest(
    '/tpo/portfolioHealth/getActualVsPreviousPeriodData',
    payload
  );
  return response;
};

export const fetchUploadsInProgress = async (selectedBu) => {
  try {
    const flow = 'BulkUpload';

    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/bulkUpload/uploadStatusByFlow/${flow}?buName=${encodeURIComponent(selectedBu)}`
    );

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchUploadsInProgressByUserId = async (userName, selectedBu) => {
  try {
    const flow = 'BulkUpload';
    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/bulkUpload/uploadStatus/${userName}?buName=${encodeURIComponent(selectedBu)}&flow=${flow}`
    );
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchMasterFillDropdownOptionsData = async (buName) => {
  try {
    const response = await axios.getRequest(
      `/tpo/portfolioMasterData/getQuickFillColumnData/${encodeURIComponent(buName)}`
    );
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchImpactedSkusCount = async (buName, payload) => {
  try {
    const response = await axios.postRequest(
      `/tpo/portfolioMasterData/filterQuickFillData?buName=${encodeURIComponent(buName)}`,
      payload
    );
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const applyConditionsAndActions = async (buName, userName, payload, count) => {
  try {
    const response = await axios.postRequest(
      `/tpo/portfolioMasterData/quickFillMasterData?userName=${userName}&buName=${encodeURIComponent(buName)}`,
      payload
    );
    triggerNotification(`Master data quick fill selections have impacted ${count} SKUs`);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const getWaterfallChartData = async (params) => {
  try {
    const response = await axios.postRequest(`/tpo/portfolioHealth/waterfallChartData`, params);

    return response;
  } catch (error) {
    const errorMessage = error?.response?.data;
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const getQuickFillLogsData = async (buName) => {
  try {
    const response = await axios.getRequest(`/tpo/portfolioMasterData/quickFillLogs/${encodeURIComponent(buName)}`);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
